import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/reducers';
import { Alert } from '@patternfly/react-core';
import SplashPage from '../splash/SplashPage';
import { getIsLoggedIntoAtLeastOneAppAuth } from '../../store/selectors';
import { useTranslation } from 'react-i18next';
import { ACCESS_RIGHTS_VALID, isInitialAccessRights } from '../../store/access-rights';

/** Wrapper component to use when the app requires cloud authentication. Otherwise use NoAuthPage. */
const AuthenticatedPage = (props: React.PropsWithChildren<{}>) => {
    const { t } = useTranslation();

    // const auths = useSelector((state: StoreState) => state.appAuthStates);
    const loginError = useSelector((state: StoreState) => state.loginError);
    const accessRights = useSelector((state: StoreState) => state.accessRights);
    const accessRightsError = useSelector((state: StoreState) => state.accessRightsError);

    const isWaitingForLogin = !useSelector(getIsLoggedIntoAtLeastOneAppAuth);
    const wasLoginSuccessful = loginError === null && accessRightsError === null;
    const hasAccessRights = wasLoginSuccessful && accessRights && accessRights.configui.includes(ACCESS_RIGHTS_VALID);
    const isLoadingAccessRights = wasLoginSuccessful && isInitialAccessRights(accessRights);
    const arePopupsBlocked = !wasLoginSuccessful && loginError && loginError.arePopupsBlocked;
    const loginErrorMessage = accessRightsError !== null ? accessRightsError : !wasLoginSuccessful && !arePopupsBlocked && loginError && loginError.errorMessage;


    const googleChromeSupportUrl = 'https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DDesktop&hl=en#zippy=%2Callow-pop-ups-from-a-site';

    return (
        <>
            {arePopupsBlocked && (<Alert variant="danger" title={t('error.popupsBlocked.title')}>
                <p>{t('error.popupsBlocked.paragraph1', { appName: t('appTitle') })}</p>
                <p>{t('error.popupsBlocked.paragraph2')}</p>
                <p><a href={googleChromeSupportUrl} target="_blank" rel="noopener noreferrer">{googleChromeSupportUrl}</a></p>
                <p>{t('error.popupsBlocked.paragraph3')}</p>
                <p>{t('error.popupsBlocked.paragraph4', { appName: t('appTitle') })}</p>
            </Alert>)}
            {!wasLoginSuccessful && loginErrorMessage && (<Alert variant="danger" title={t('error.loginError.title', { loginErrorMessage: loginErrorMessage })}>
                <p>{t('error.loginError.paragraph1')}</p>
                <p>{loginErrorMessage}</p>
                <p>{t('error.loginError.paragraph2')}</p>
            </Alert>)}
            {(isWaitingForLogin || isLoadingAccessRights) && (<SplashPage loadingText={t('splash.waitingForLogin')} />)}
            {!isWaitingForLogin && !hasAccessRights && !isInitialAccessRights(accessRights) && !isLoadingAccessRights && <SplashPage loadingText={t('error.accessRightsError')} />}
            {!isWaitingForLogin && !isLoadingAccessRights && !isInitialAccessRights(accessRights) && hasAccessRights && props.children}
        </>
    );
}

export default AuthenticatedPage;
